export default __webpack_public_path__ + "static/media/mlady.2e04cd6e.png";